module.exports = __webpack_public_path__ + "static/images/gfb-redirect.22Le6JS.png";